import React, { Children, Fragment } from 'react';
import get from 'lodash.get';
import set from 'lodash.set';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { array, arrayOf, componentName, element, mapper, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ExperimentalFlagsService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getLostProps, isFunction, propagateData } from '@philips-internal/oswald-ui-utils';
import { MapperAPI } from './mapper-api.js';
function map(options) {
    if (Array.isArray(options.data)) {
        return options.data.map((item) => mapObject({ ...options, data: item }));
    }
    return mapObject(options);
}
function isObject(target) {
    return typeof target === 'object';
}
function filterEntriesBy(targetKey) {
    return ([key]) => key.startsWith(`${targetKey}.`);
}
function normalizeEntries(sourceKey, sourceValue) {
    return ([key, value]) => ([
        key.replace(`${sourceKey}.`, ''),
        value.replace(`${sourceValue}.`, ''),
    ]);
}
function resultFromEntries(result, [key, value]) {
    result[key] = value;
    return result;
}
function mapObject(options) {
    if (!isObject(options.data)) {
        return options.data;
    }
    const result = ExperimentalFlagsService.getMapperOnlyPropagateMappedKeys()
        ? {}
        : { ...options.data };
    const mapEntries = Object.entries(options.map);
    for (const [componentKey, dataKey] of mapEntries) {
        let value = get(options.data, dataKey);
        if (!value) {
            continue;
        }
        if (Array.isArray(value)) {
            const valueMap = mapEntries
                .filter(filterEntriesBy(componentKey));
            if (valueMap.length > 0) {
                value = map({
                    ...options,
                    data: value,
                    map: mapEntries
                        .map(normalizeEntries(componentKey, dataKey))
                        .reduce(resultFromEntries, {}),
                });
            }
        }
        set(result, componentKey, value);
    }
    return applyCustomMapping({
        customMapping: options.customMapping,
        mappedData: result,
        originalData: options.data,
    });
}
function applyCustomMapping(options) {
    if (!options.customMapping || !options.originalData) {
        return options.mappedData;
    }
    const entries = Object.entries(options.customMapping);
    for (const [name, value] of entries) {
        if (isFunction(value)) {
            options.mappedData[name] = value(options.originalData);
        }
    }
    return options.mappedData;
}
const MapperContainer = {
    name: '',
};
function Mapper(props) {
    const lostProps = getLostProps(Mapper.propTypes, props);
    if (Children.count(props.children) === 0) {
        return (React.createElement(Container, { className: "u-expand", uuid: props.uuid }));
    }
    const mappedData = map({
        customMapping: props.customMapping,
        data: props.data,
        map: props.map,
    });
    return (React.createElement(Fragment, null, propagateData(props.children, mappedData, lostProps)));
}
Mapper.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    component: componentName(ComponentType.DATA_DISPLAY),
    customMapping: object.notEnumerable(),
    data: oneOfType([object, array]).notEnumerable(),
    map: mapper,
    uuid: string,
};
Mapper.defaultProps = {
    customMapping: {},
    map: {},
    uuid: '',
};
const awesomeProps = {
    api: MapperAPI,
    containers: [MapperContainer],
    type: ComponentType.BEHAVIOR,
};
AwesomeComponent(awesomeProps)(Mapper);
export { Mapper, };
//# sourceMappingURL=mapper.js.map